/** Каталог якорей модуля «Обращения граждан» */
export const APPEALS_ANCHORS = {
  /** Шестерёнка настроек модуля у пункта «Обращения граждан» в боковом меню */
  nav: {
    settings: 'appeals.nav.settings',
  },
  table: {
    create: 'appeals.table.create',
    qr: 'appeals.table.qr',
    settings: 'appeals.table.settings',
    search: 'appeals.table.search',
    resetFilters: 'appeals.table.resetFilters',
    hideAnswered: 'appeals.table.hideAnswered',
    /** Префикс якоря значка фильтра в заголовке колонки, дальше — ключ колонки из `headers` */
    filterPrefix: 'appeals.table.filter.',
    filterFirst: 'appeals.table.filter.number',
    filterLast: 'appeals.table.filter.status',
    demoRow: 'appeals.table.demoRow',
  },
  settings: {
    addChannel: 'appeals.settings.addChannel',
    channels: 'appeals.settings.channels',
  },
  form: {
    channelTopic: 'appeals.form.channelTopic',
    rating: 'appeals.form.rating',
    applicant: 'appeals.form.applicant',
    contacts: 'appeals.form.contacts',
    target: 'appeals.form.target',
    text: 'appeals.form.text',
    reply: 'appeals.form.reply',
    assignCoordinator: 'appeals.form.assignCoordinator',
  },
} as const

/** Имена контекстов модуля */
export const APPEALS_CONTEXTS = {
  table: 'appeals.table',
  settings: 'appeals.settings',
  form: 'appeals.form',
  formTasks: 'appeals.form.tasks',
} as const
